import config from '../../front/config/config-server';
//import getAuthCookie from '../auth/getAuthCookie';

const createReservation = async (newReservation) => {
    const API_RESERVATION = `${config.apiUrl}/api/reservation/create-new`;

    //const token = getAuthCookie('token');

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const data = await fetch(API_RESERVATION, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newReservation)
    })
        .then((res) => {
            return res.json();

        })
        .catch(err => {
            return err;
        })

    return data;
}

export default createReservation;